import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/accedi", { replace: true });
      return;
    }
    api
      .get(`/auth/session`, { params: { session_id: sessionId } })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/accedi", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBF8F3]">
      <p className="font-display text-2xl italic text-[#5C534B]">Accesso in corso...</p>
    </div>
  );
};
